(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('primal-countdown')) {
    customElements.define(
      'primal-countdown',
      class PrimalCountdown extends HTMLElement {
        connectedCallback() {
          this.timer = this.querySelector('[data-countdown-timer]');
          this.units = this.querySelector('.primal-countdown__units');
          this.expiredMessage = this.querySelector('[data-countdown-expired]');
          this.status = this.querySelector('[data-countdown-status]');
          this.values = Object.fromEntries(
            [...this.querySelectorAll('[data-countdown-value]')].map((element) => [
              element.dataset.countdownValue,
              element,
            ])
          );

          this.duration = this.getDailyDuration();
          this.targetTime = this.getTargetTime();
          this.headerGroup = this.closest('#header-group');
          this.updateStickyOffset();

          this.resizeObserver = new ResizeObserver(() => this.updateStickyOffset());
          this.resizeObserver.observe(this);

          this.update();
          if (Number.isFinite(this.targetTime)) {
            this.interval = window.setInterval(() => this.update(), 1000);
          }
        }

        disconnectedCallback() {
          window.clearInterval(this.interval);
          this.resizeObserver?.disconnect();

          this.headerGroup?.style.removeProperty('--primal-countdown-sticky-height');
        }

        getDailyDuration() {
          const hours = Math.max(0, Number.parseInt(this.dataset.dailyHours, 10) || 0);
          const minutes = Math.max(0, Number.parseInt(this.dataset.dailyMinutes, 10) || 0);
          const duration = (hours * 60 + minutes) * 60 * 1000;

          return duration > 0 ? duration : 24 * 60 * 60 * 1000;
        }

        getTargetTime() {
          if (this.dataset.timerMode === 'daily') {
            return this.getEvergreenTarget();
          }

          const normalizedEndTime = (this.dataset.endTime || '').trim().replace(/\s+/, 'T');
          const parsedTime = new Date(normalizedEndTime).getTime();

          return Number.isFinite(parsedTime) ? parsedTime : Number.NaN;
        }

        getEvergreenTarget() {
          const now = Date.now();
          const storageKey = `primal-countdown:${this.dataset.sectionId}:${this.duration}`;

          try {
            const storedTarget = Number.parseInt(window.localStorage.getItem(storageKey), 10);
            if (Number.isFinite(storedTarget) && storedTarget > now && storedTarget <= now + this.duration) {
              return storedTarget;
            }

            const nextTarget = now + this.duration;
            window.localStorage.setItem(storageKey, String(nextTarget));
            return nextTarget;
          } catch (error) {
            return now + this.duration;
          }
        }

        update() {
          if (!Number.isFinite(this.targetTime)) {
            this.showExpired();
            return;
          }

          let remaining = this.targetTime - Date.now();

          if (remaining <= 0 && this.dataset.timerMode === 'daily') {
            this.targetTime = this.getEvergreenTarget();
            remaining = this.targetTime - Date.now();
          }

          if (remaining <= 0) {
            this.showExpired();
            return;
          }

          const days = Math.floor(remaining / 86400000);
          const hours = Math.floor((remaining % 86400000) / 3600000);
          const minutes = Math.floor((remaining % 3600000) / 60000);
          const seconds = Math.floor((remaining % 60000) / 1000);

          this.values.days.textContent = String(days).padStart(2, '0');
          this.values.hours.textContent = String(hours).padStart(2, '0');
          this.values.minutes.textContent = String(minutes).padStart(2, '0');
          this.values.seconds.textContent = String(seconds).padStart(2, '0');
          this.timer.setAttribute(
            'aria-label',
            `Offer ends in ${days} days, ${hours} hours, ${minutes} minutes and ${seconds} seconds`
          );
        }

        showExpired() {
          window.clearInterval(this.interval);

          if (this.dataset.hideWhenExpired === 'true') {
            this.hidden = true;
            this.updateStickyOffset();
            return;
          }

          this.units.hidden = true;
          this.expiredMessage.hidden = false;
          this.status.textContent = this.expiredMessage.textContent.trim();
          this.timer.setAttribute('aria-label', this.status.textContent);
        }

        updateStickyOffset() {
          if (this.dataset.sticky !== 'true') return;

          if (!this.headerGroup) return;

          const sectionElement = this.closest('.shopify-section');
          const height = this.hidden ? 0 : Math.round(sectionElement?.offsetHeight || this.offsetHeight);
          this.headerGroup.style.setProperty('--primal-countdown-sticky-height', `${height}px`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
